(function init_debug($) {
    const $debug_box = $('.debug-box');
    console.log("%cTheme Debug aktiv!", "color: red; font-size: 21px");
    $debug_box.on('click', function toggle_body_debug_class() {
        $('body').toggleClass('debug-body');
    });

})(jQuery);
